/* Live predictive search. Attaches to any <form data-predictive-search> that
   contains an input[name="q"] and a [data-predictive-results] panel. Fetches the
   predictive-search section via the Section Rendering API and injects its markup. */
(function () {
  var ENDPOINT = '/search/suggest';
  var SECTION = 'predictive-search';
  var MIN = 2;

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function attach(form) {
    if (form.dataset.psInit) return;
    form.dataset.psInit = '1';
    var input = form.querySelector('input[name="q"]');
    var panel = form.querySelector('[data-predictive-results]');
    if (!input || !panel) return;
    var controller;

    function close() {
      form.classList.remove('is-ps-open');
      input.setAttribute('aria-expanded', 'false');
    }
    function openIfContent() {
      if (panel.innerHTML.trim()) {
        form.classList.add('is-ps-open');
        input.setAttribute('aria-expanded', 'true');
      } else {
        close();
      }
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < MIN) { panel.innerHTML = ''; close(); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      var url = ENDPOINT + '?q=' + encodeURIComponent(q) +
        '&section_id=' + SECTION +
        '&resources[type]=product,page,article' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          panel.innerHTML = inner ? inner.innerHTML : '';
          openIfContent();
        })
        .catch(function (e) { if (e.name !== 'AbortError') { panel.innerHTML = ''; close(); } });
    }, 220);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (input.value.trim().length >= MIN) openIfContent(); });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = Array.prototype.slice.call(panel.querySelectorAll('a'));
      if (!items.length || !form.classList.contains('is-ps-open')) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { (items[i + 1] || items[0]).focus(); }
      else { (i <= 0 ? items[items.length - 1] : items[i - 1]).focus(); }
    });

    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  function boot() {
    document.querySelectorAll('form[data-predictive-search]').forEach(attach);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
